import React, { useState } from 'react';

export function FAQItem({ q, a, index, testIdPrefix = 'faq' }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="py-2">
      <button
        type="button"
        data-testid={`${testIdPrefix}-${index}`}
        onClick={() => setOpen((s) => !s)}
        className="w-full text-left py-5 grid grid-cols-12 gap-4 items-baseline group"
      >
        <div className="col-span-1 text-xs uppercase tracking-[0.22em] text-ink-muted tabular-nums">
          0{index + 1}
        </div>
        <div className="col-span-9 md:col-span-10 text-lg md:text-xl font-semibold tracking-tight group-hover:text-white">
          {q}
        </div>
        <div className="col-span-2 md:col-span-1 text-right text-ink-muted">
          <span className={`inline-block transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>＋</span>
        </div>
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-500 ease-out"
        style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <div className="grid grid-cols-12 gap-4 pb-6">
            <div className="col-span-1" />
            <p className="col-span-11 text-ink-muted leading-relaxed max-w-2xl">{a}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FAQList({ items, testIdPrefix = 'faq' }) {
  return (
    <div className="divide-y divide-white/10 border-y border-white/10">
      {items.map((it, i) => (
        <FAQItem key={it.q} q={it.q} a={it.a} index={i} testIdPrefix={testIdPrefix} />
      ))}
    </div>
  );
}
